import { Injectable } from '@angular/core';
import { Params, Router } from '@angular/router';

export const NAVIGATIONURLS = {
	tos: () => 'tos',
	faq: () => 'faq',
	map: () => 'map',
	mapVenue: (venueId?: string) => `map/${venueId}`,
	home: () => 'home',
	menu: () => 'menu',
	order: () => 'order',
	signIn: () => 'sign-in',
	allInfo: () => 'account',
	signUp: () => 'sign-up',
	privacy: () => 'privacy',
	promo: () => 'promotions',
	loyalty: () => 'loyalty',
	privacyApp: () => 'privacy-app',
	mapTesting: () => 'map/testing/smoothr',
	cookie: () => 'cookie',
	account: () => 'user-data',
	myOrders: () => 'my-orders',
	impressum: () => 'impressum',
	foodSpot: () => 'food-spot',
	maintenance: () => 'maintenance',
	emailAction: () => 'email-action',
	paymentFail: () => 'payment/failed',
	confirmEmail: () => 'confirm-email',
	paymentCancel: () => 'payment/cancel',
	paymentSuccess: () => 'payment/success',
	selectCategory: () => 'select-category',
	paymentFailPaymentId: (paymentId?: string) => `payment/failed/${paymentId}`,
	paymentCancelPaymentId: (paymentId?: string) => `payment/cancel/${paymentId}`,
	paymentSuccessPaymentId: (paymentId?: string) => `payment/success/${paymentId}`,
};
export const navPaymentSuccess = async (router: Router, order: string, payment: string) => {
	await router.navigate([NAVIGATIONURLS.paymentSuccessPaymentId(payment)], {
		queryParams: {
			order,
		},
	});
};
@Injectable({
	providedIn: 'root',
})
export class NavigationService {
	constructor(private router: Router) {}
	async menu() {
		await this.router.navigateByUrl(NAVIGATIONURLS.menu());
	}

	async home() {
		await this.router.navigateByUrl(NAVIGATIONURLS.home());
	}
	async homeWithTable(venueId: string, tableNumber: string) {
		await this.router.navigate(['venue', venueId, 'table', tableNumber]);;
	}

	async order(largeScreen = false) {
		return this.router.navigateByUrl(largeScreen ? NAVIGATIONURLS.menu() : NAVIGATIONURLS.order());
	}

	async imprint() {
		await this.router.navigateByUrl(NAVIGATIONURLS.impressum());
	}

	async paymentSuccess(order: string, payment: string = '') {
		await this.router.navigate([NAVIGATIONURLS.paymentSuccessPaymentId(payment)], {
			queryParams: {
				order,
			},
		});
	}
	async paymentError(order: string, payment: string) {
		await this.router.navigate([NAVIGATIONURLS.paymentFailPaymentId(payment)], {
			queryParams: {
				order,
			},
		});
	}
	async maintenance() {
		await this.router.navigateByUrl(NAVIGATIONURLS.maintenance(), {
			skipLocationChange: true,
			replaceUrl: false,
		});
	}
	async faq() {
		await this.router.navigateByUrl(NAVIGATIONURLS.faq());
	}
	async tos() {
		await this.router.navigateByUrl(NAVIGATIONURLS.tos());
	}
	async signUp() {
		await this.router.navigateByUrl(NAVIGATIONURLS.signUp());
	}
	async signIn() {
		await this.router.navigateByUrl(NAVIGATIONURLS.signIn());
	}
	async myOrders() {
		await this.router.navigateByUrl(NAVIGATIONURLS.myOrders());
	}
	async account() {
		await this.router.navigateByUrl(NAVIGATIONURLS.account());
	}
	async cookie() {
		await this.router.navigateByUrl(NAVIGATIONURLS.cookie());
	}
	async privacy() {
		await this.router.navigateByUrl(NAVIGATIONURLS.privacy());
	}
	async privacyApp() {
		await this.router.navigateByUrl(NAVIGATIONURLS.privacyApp());
	}
	async emailConfirmation() {
		await this.router.navigateByUrl(NAVIGATIONURLS.confirmEmail());
	}
	async map() {
		console.log('MAP');
		setTimeout(() => {
			this.router.navigate([NAVIGATIONURLS.map()]);
		}, 250);
	}
	async mapWithParams(queryParams: Params = {}) {
		console.log(queryParams);
		await this.router.navigate([NAVIGATIONURLS.map()], {
			queryParams,
			replaceUrl: true,
		});
	}
	async navigateToUrl(url: string) {
		await this.router.navigateByUrl(url);
	}
	async foodSpot() {
		await this.router.navigateByUrl(NAVIGATIONURLS.foodSpot());
	}
	async navigateToUrlWithParams(url: string, queryParams: Params) {
		await this.router.navigate([url], {
			queryParams,
			replaceUrl: true,
		});
	}
	async navigateSelectedCategory(categoryId?: string) {
		let queryParams = {};
		if (categoryId) {
			queryParams = {
				categoryId,
			};
		}
		await this.router.navigate([NAVIGATIONURLS.selectCategory()], {
			queryParams,
			replaceUrl: true,
		});
	}
	async promo() {
		await this.router.navigateByUrl(NAVIGATIONURLS.promo());
	}
	async loyalty() {
		await this.router.navigateByUrl(NAVIGATIONURLS.loyalty());
	}
}
